const rootMargin = window.matchMedia('(max-width: 992px)').matches ? '-100px 0px' : '-200px 0px';
const sections = document.querySelectorAll('.shopify-section');
sections.forEach((section) => {
    const obs = new IntersectionObserver((entries, observer) => {
        if(entries[0].isIntersecting) {
            section.classList.add('shopify-section--reveal');
            observer.unobserve(section);
        }
    }, {
        rootMargin,
        root: null,
        threshold: 0
    })
    obs.observe(section);
    // Failsafe: guarantee every section becomes visible even if the
    // IntersectionObserver misses the initial in-view state (this was
    // leaving above-the-fold sections stuck at opacity:0 on mobile
    // until the visitor scrolled).
    setTimeout(() => {
        section.classList.add('shopify-section--reveal');
        obs.unobserve(section);
    }, 1200);
})
